import { connect } from 'react-redux';
import { getNumberKeys } from '../../../../../../../../helper/getNumberKeys';
import {
    getBoardCardCustomProperties
} from '../../../../../../../../store/model/board/selectors/getBoardCardCustomProperties';
import { IApplicationState } from '../../../../../../../../types/types';
import { CustomPropertiesPanelButton } from '../../components/CustomPropertiesPanelButton/CustomPropertiesPanelButton';
import {
    ICustomPropertiesPanelButtonEvents,
    ICustomPropertiesPanelButtonFields
} from '../../components/CustomPropertiesPanelButton/types';
import { onClick } from './events/onClick';
import { ICustomPropertiesPanelButtonHOCProps } from './types';
import {
    getIsUserEssentialPlanOnly
} from '../../../../../../../../store/model/authUser/selectors/getIsUserEssentialPlanOnly';

const mapStateToProps = (
    state: IApplicationState,
    { boardId }: ICustomPropertiesPanelButtonHOCProps
): ICustomPropertiesPanelButtonFields => {
    const CardCustomProperties = getBoardCardCustomProperties(state, boardId);
    const indicatorNumber = getNumberKeys(CardCustomProperties).length;
    return {
        indicatorNumber,
        isEssentialFeature: getIsUserEssentialPlanOnly(state)
    }
};

const mapDispatchToProps = (
    dispatch: any,
    {onClick: ownOnClick}: ICustomPropertiesPanelButtonHOCProps
): ICustomPropertiesPanelButtonEvents => {
    return {
        onClick: () => dispatch(onClick(ownOnClick))
    }
};

export const CustomPropertiesPanelButtonHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(CustomPropertiesPanelButton);

CustomPropertiesPanelButtonHOC.displayName = 'CustomPropertiesPanelButtonHOC';
